import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Vehicle } from '../../../DataStructures/Vehicle/Vehicle';
import { Trip } from '../../../DataStructures/Trip/Trip';
import { VehicleReservation } from '../../../DataStructures/VehicleReservation/VehicleReservation';
import { OptionRank } from '../../../DataStructures/OptionRank/OptionRank';
import { Suggestion } from '../../../utilities/VehicleSuggestion/Suggestion';

@Component({
  selector: 'app-no-more-vehicles-dialog',
  templateUrl: './no-more-vehicles-dialog.component.html',
  styleUrls: ['./no-more-vehicles-dialog.component.css']
})
export class NoMoreVehiclesDialogComponent {

  vehicleSuggestions: Array<Suggestion>;
  tripToIncludeRemainingPassengersOn:Trip;
  tripWithRemainingPassengers:Trip;
  tripWithVehicleToWaitOn:Trip;
  noTripsToIncludeRemainingPassengersOn = false;
  noTripsToWaitOn = false;
  newTime:number;
  waitTime:number;
  tripTimeForSecondOption:number;
  roundTripTime:number;
  optionRanks:Array<OptionRank>

  constructor(
    public dialogRef: MatDialogRef<NoMoreVehiclesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.dialogRef.disableClose = true;
      this.tripToIncludeRemainingPassengersOn = data.tripToIncludeRemainingPassengersOn; 
      this.tripWithRemainingPassengers = data.tripNoVehiclesAvailableFor;
      this.tripWithVehicleToWaitOn = data.tripWithVehicleToWaitOn;
      this.vehicleSuggestions = data.suggestions;
      this.roundTripTime = Math.round(data.roundTripTime/60);


      //Option 1
      if(this.tripToIncludeRemainingPassengersOn != null){

        var time = this.tripToIncludeRemainingPassengersOn.snapShotTime;
        this.newTime = time ? Math.round(time / 60) : 0;

      }else{

        this.noTripsToIncludeRemainingPassengersOn = true;
      }

      //Option 2
      if(this.tripWithVehicleToWaitOn != null){
        var time = this.tripWithVehicleToWaitOn.vehicleReservation.getTimeVehicleWillBeAvailableForTripAfterLastTrip(this.tripWithVehicleToWaitOn);
        this.waitTime = Math.round(time / 60);
        this.tripTimeForSecondOption = data.tripTimeForSecondOption;
      }else{
        this.noTripsToWaitOn = true;        
      }

      this.calculateOptionTotals();
    }

    calculateOptionTotals(){
      var optionOneTotal = null;
      var optionTwoTotal = null;
      var optionThreeTotal = -9999999999999;

      var options = new Array<OptionRank>();
      for(var i = 0; i < 3;i++){
        options.push(new OptionRank(i+1));
      }

      if(this.tripToIncludeRemainingPassengersOn != null){

        optionOneTotal = this.newTime - this.roundTripTime; 
        options[0].total = optionOneTotal;
      }

      if(this.tripWithVehicleToWaitOn != null){
        optionTwoTotal =  (this.waitTime - this.roundTripTime) + Math.round(this.tripWithVehicleToWaitOn.time/60);
        options[1].total = optionTwoTotal;
      }

      options[2].total = optionThreeTotal;

      var optionsToRank = [];
      options.forEach(o =>{
        if(o.total != null){
          optionsToRank.push(o);
        }
      })
      this.rankOptions(optionsToRank);
    }

    rankOptions(options:Array<OptionRank>){

      var sortedTotals = options.sort(function(a, b){return a.total-b.total});
      var ranks = new Array<OptionRank>();
      var option = null;

      for(var i = 0; i < sortedTotals.length;i++){
        option = sortedTotals[i];
        if(i == 0){
          var o = new OptionRank(option.option)
          o.text = "(Best Option)";
          o.total = option.total;
          ranks.push(o);
        }else if(i == 1){
          var o = new OptionRank(option.option)
          o.text = "(Second Best Option)";
          o.total = option.total;
          ranks.push(o);
        }else{
          var o = new OptionRank(option.option)
          o.text = "(Worst Option)";
          o.total = option.total;
          ranks.push(o);
        }
      }

      this.optionRanks = ranks;
    }

    getOptionText(i:number){

      return this.optionRanks.find(o => o.option ==i).text;
    }

    yes(){
      
      this.dialogRef.close({choice:"yes"});
    }

    no(){

      this.dialogRef.close({choice:"no"});
    }

    add(){
      this.dialogRef.close({choice:"add"});
    }

}
